// ── ListRow — строка списка ──────────────────────────────────────────────────
// [before] [значок] Название                       [trailing]
//                   подпись · подробности
// Название и подпись сжимаются (minWidth: 0) и укорачиваются «…» — кнопки
// справа никогда не уезжают за край. lines={2} — название в две строки.
// Нажатие по строке — отдельная кнопка на всю середину; кнопки слева (before,
// например «▶») и справа (trailing, например «⋯») — свои, рядом: кнопка в
// кнопке не допускается HTML и путает экранного диктора и клавиатуру.
// children вместо названия и подписи — например, поле переименования.
// Строки подряд разделяет тонкая линия (divider); подсветка при наведении — на
// всю строку; highlight — строка выделена (сюда перетаскивают, выбрана).

import Icon from '../Icon';
import { SANS } from '../themes';
import { usePalette } from './theme';

const clamp = (lines) => (lines > 1
  ? { display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: lines, overflow: 'hidden', overflowWrap: 'anywhere' }
  : { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' });

export default function ListRow({
  leading, before, title, subtitle, meta, trailing, children, onClick, label, tip, chevron = false, lines = 1,
  active = false, highlight = false, strong = false, dense = false, divider = true, className = '', style, C: Cp, ...rest
}) {
  const C = usePalette(Cp);
  const padY = dense ? 6 : 8;
  const body = (
    <>
      {leading && <span style={{ flexShrink: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>{leading}</span>}
      {children ?? (
        <span style={{ flex: '1 1 auto', minWidth: 0, display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'left' }}>
          <span style={{ fontSize: dense ? 14 : 15, fontWeight: strong ? 600 : 500, color: active ? C.blueDark : C.text, lineHeight: 1.3, ...clamp(lines) }}>{title}</span>
          {subtitle != null && subtitle !== false && subtitle !== '' && (
            <span style={{ fontSize: 12.5, color: C.faint, lineHeight: 1.35, ...clamp(1) }}>{subtitle}</span>
          )}
        </span>
      )}
      {meta != null && meta !== false && <span style={{ flexShrink: 0, fontSize: 13, color: C.mid, whiteSpace: 'nowrap' }}>{meta}</span>}
      {chevron && <span aria-hidden="true" style={{ color: C.faint, display: 'inline-flex', flexShrink: 0 }}><Icon n="chevronRight" s={18} /></span>}
    </>
  );
  const main = { flex: '1 1 auto', minWidth: 0, display: 'flex', alignItems: 'center', gap: 12, padding: `${padY}px 12px ${padY}px ${before ? 0 : 12}px` };
  return (
    <div className={['ac-row', onClick ? 'ac-row-click' : '', divider ? 'ac-row-div' : '', className].filter(Boolean).join(' ')}
      data-hl={active || highlight ? '1' : undefined}
      style={{ '--ac-row-hover': C.surface, '--ac-row-line': C.borderSoft, display: 'flex', alignItems: 'stretch', minHeight: dense ? 44 : 60, minWidth: 0,
        background: active || highlight ? C.bluePale : undefined, color: C.text, fontFamily: SANS, ...style }} {...rest}>
      {before && <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', padding: '0 12px' }}>{before}</div>}
      {onClick ? (
        <button type="button" onClick={onClick} aria-label={label} title={tip}
          style={{ ...main, background: 'none', border: 'none', borderRadius: 0, cursor: 'pointer', color: 'inherit', font: 'inherit', textAlign: 'left' }}>
          {body}
        </button>
      ) : (
        <div style={main}>{body}</div>
      )}
      {trailing && (
        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 4, paddingRight: 4 }}>{trailing}</div>
      )}
    </div>
  );
}
